<template>
    <svg
        viewBox="0 0 59 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="59"
        height="66"
        class="relative z-30 h-[2.75rem] w-auto lg:h-[3.75rem] xl:h-[4.75rem]">
        <g>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 21.2663H58.3572V18.8113H0V21.2663Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M44.7078 25.7366H38.257V48.6892H35.171V33.1158C35.171 31.8119 35.0964 30.9872 34.8542 30.1814C34.3869 28.5708 33.3013 26.8492 31.9371 26.1582C31.1134 25.7366 30.1604 25.564 29.1693 25.564C28.0108 25.564 26.9253 25.8132 26.01 26.3885C24.7936 27.1365 23.8586 28.7621 23.4294 30.3353C23.2239 31.0639 23.1676 31.8688 23.1676 33.1158V48.6892H20.083V25.7366H13.6316V48.6892H10.5843L10.5462 25.7366H4.3009V48.6892H1.23465V25.7366H0V23.2817H58.3568V25.7366H57.1237V48.6892H54.0574V25.7366H47.774V48.6892H44.7078V25.7366Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.873047 15.0028L2.66804 12.5478L4.44473 15.0028L2.66804 17.4578L0.873047 15.0028Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.00779 58.6695C10.0538 59.13 10.9519 60.2429 10.9519 61.8536C10.9519 63.9252 9.84832 65.2479 8.44599 65.6507C7.58569 65.9193 6.68906 65.9193 5.86683 65.9193H0.873047V51.8998H6.16532C6.81985 51.8998 7.54936 51.9184 8.27856 52.1107C9.53153 52.4556 10.69 53.5299 10.69 55.5056C10.69 57.3273 9.68062 58.2094 9.00779 58.574V58.6695ZM6.25803 57.9793C6.74544 57.9793 7.19302 57.9215 7.56738 57.6919C8.10942 57.3849 8.48406 56.7328 8.48406 55.7548C8.48406 54.7957 8.03501 54.1626 7.38021 53.9331C7.06369 53.7985 6.67075 53.7595 6.16532 53.7595H3.04267V57.9793H6.25803ZM8.68954 61.8536C8.68954 60.837 8.20387 60.2616 7.62376 60.0124C7.24941 59.8586 6.81985 59.8204 6.4455 59.8204H3.04267V64.0781H6.40888C6.81985 64.0781 7.21279 64.04 7.53104 63.9252C8.26025 63.6369 8.68954 62.9656 8.68954 61.8536Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.5995 14.9068C11.1321 14.7341 10.7955 14.2929 10.7955 13.7567C10.7955 13.085 11.3193 12.5478 11.9924 12.5478C12.6469 12.5478 13.1707 13.085 13.1707 13.7567C13.1707 14.2929 12.8524 14.7341 12.3851 14.888L13.5255 17.2664H10.459L11.5995 14.9068Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.2619 63.8673L26.8033 65.9191H13.0781L20.5201 51.8998H25.0828V63.9251L28.2619 63.8673ZM22.9513 64.0202V53.6065H21.5309L16.1262 64.0202H22.9513Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.0566 17.0896H38.2306V14.6347H20.0566V17.0896Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M25.5762 12.6193H32.9436V10.1643H25.5762V12.6193Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.4453 3.65685H31.8683V1.22067H26.4453V3.65685Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.0293 5.69247H31.0305L29.0298 8.45421L27.0293 5.69247Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M42.646 51.8998V65.9195H40.4764V59.4177H33.5399V65.9195H31.3887V51.8998H33.5399V57.4999H40.4764V51.8998H42.646Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M45.9002 14.888C45.4329 14.7341 45.1146 14.2929 45.1146 13.7567C45.1146 13.085 45.6384 12.5478 46.2932 12.5478C46.966 12.5478 47.4897 13.085 47.4897 13.7567C47.4897 14.2929 47.1532 14.7341 46.6858 14.9068L47.8263 17.2664H44.7598L45.9002 14.888Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M52.1379 60.2038L48.3805 65.9193H46.2109L51.1103 58.6891L46.4362 51.8998H49.0351L52.4379 56.848L55.6716 51.8998H57.7666L53.4473 58.3438L58.6452 65.9193H56.0645L52.1379 60.2038Z"
                fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M53.7676 15.0028L55.5443 12.5478L57.3393 15.0028L55.5443 17.4577L53.7676 15.0028Z"
                fill="currentColor" />
        </g>
    </svg>
</template>
